import { Controller, ActionEvent } from '@hotwired/stimulus'

enum VariantType {
  Color = 'color',
  Connector = 'connector',
}

export type VariantSelectEvent = CustomEvent<{
  variant: string
  type: VariantType
}>;

export default class extends Controller {
  static targets = [ 'variant', 'variantname' ]
  static values = {
    variant: String,
    type: String,
  }

  declare variantValue: string
  declare typeValue: VariantType

  declare readonly variantTargets: HTMLDivElement[]
  declare readonly variantnameTarget: HTMLDivElement
  declare hasVariantnameTarget: boolean

  variantValueChanged() {


    this.dispatch('variant-selected', {
      detail: {
        variant: this.variantValue,
        type: this.typeValue,
      }
    })

    if (this.hasVariantnameTarget) {
      this.variantnameTarget.innerHTML = this.variantValue
    }

    this.variantTargets.forEach((el) => {
      const variant = el.dataset.productVariantVariantParam!
      if (variant !== this.variantValue) {
        this.unselectVariant(el, variant)
        return
      }
      this.selectVariant(el, variant)
    })
  }

  unselectVariant(el: HTMLDivElement, variant: string) {
    switch (this.typeValue) {
      case VariantType.Color:
        el.innerHTML = ''
        el.className = `bg-${variant}-300 hover:bg-${variant}-500 focus:bg-${variant}-500 color-variant-button`
        break
      case VariantType.Connector:
        el.className = `variant-button`
    }
  }

  selectVariant(el: HTMLDivElement, variant: string) {
    switch (this.typeValue) {
      case VariantType.Color:
        el.innerHTML = this.checkSvg()
        el.className = `bg-${variant}-500 ring-${variant}-300 color-variant-button-active`
        break
      case VariantType.Connector:
        el.className = `variant-button-active`
    }
  }

  checkSvg() {
    const size = '18'
    return `
      <svg class="transition duration-300 ease-in-out" width="${size}" height="${size}" viewBox="0 0 ${size} ${size}" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g id="ri:check-fill">
        <path id="Vector" d="M7.5 11.3775L14.394 4.48425L15.4545 5.54475L7.5 13.4993L2.727 8.72625L3.7875 7.66575L7.5 11.3775Z" fill="white"/>
        </g>
      </svg>
    `
  }

  handleVariantValueChanged(event: ActionEvent) {
    this.variantValue = event.params.variant
  }
}
